// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// Suppress console warnings/errors in production - MUST be first import
import './utils/consoleSuppress';

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPage from './components/Admin/js/AdminPage';
import reportWebVitals from './reportWebVitals';


function RootComponent() {
  const [isAdminLanding, setIsAdminLanding] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAdminAccess = async () => {
      const access = localStorage.getItem('access');
      if (!access) {
        setIsChecking(false);
        return;
      }

      // Check landing flag first (for immediate redirect after login)
      const landing = localStorage.getItem('landing');
      if (landing === 'admin') {
        setIsAdminLanding(true);
        setIsChecking(false);
        // Don't remove landing flag here - let AdminPage handle it
        return;
      }

      // If no landing flag, check if user is vendor or admin
      try {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://django-backend-115705416374.asia-south1.run.app';

        // First check if user is a vendor
        const vendorResponse = await fetch(`${API_BASE_URL}/api/vendor/check-user-type/`, {
          headers: {
            'Authorization': `Bearer ${access}`
          }
        });

        if (vendorResponse.ok) {
          const vendorData = await vendorResponse.json();
          if (vendorData.is_vendor) {
            // User is a vendor - don't redirect to admin page
            setIsChecking(false);
            return;
          }
        }

        // If not a vendor, check admin permissions
        const response = await fetch(`${API_BASE_URL}/api/user-permissions/`, {
          headers: {
            'Authorization': `Bearer ${access}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          const hasAdminPerms = !!(data.isSuperAdmin || data.can_view || data.can_design || data.can_initiate || data.can_approval || data.can_status);

          if (hasAdminPerms) {
            setIsAdminLanding(true);
            // Set landing flag for future reloads
            localStorage.setItem('landing', 'admin');
          }
        }
      } catch (err) {
        // Failed to check user type or admin permissions
      } finally {
        setIsChecking(false);
      }
    };

    checkAdminAccess();
  }, []);

  // Show nothing while checking (or show a loader if needed)
  if (isChecking) {
    return null; // or return a loading spinner
  }

  // Check for admin landing flag and render AdminPage directly
  if (isAdminLanding) {
    return <AdminPage />;
  }

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();






